import { createFileRoute } from '@tanstack/react-router';
import { ThreeDSLayout } from '../components/pages/ThreeDSPage/ThreeDSLayout';

export const Route = createFileRoute('/3ds')({
  component: ThreeDSLayout,
});
